import getStringDateAndHourFromDate from '../../../localUtils/getStringDateAndHourFromDate'

export default function getToday() {
  const today = new Date()

  const { date } = getStringDateAndHourFromDate(today)

  const options = {
    name: 'TODAY',
    label: 'Hoje',
    startDate: date,
    finalDate: date,
    startHour: '00:00',
    finalHour: '23:59',
  }

  return options
}
